module.exports = __webpack_public_path__ + "img/Atelier_10.a69aa3a6.jpg";